// extracted by mini-css-extract-plugin
export default {"list":"orders-list_list__dWDv1","list_profile":"orders-list_list_profile__6NqPg"};